import Container from "../components/Container/Container";
import {Button, Form, Input, message, Modal, Space, Table, Tag} from "antd";
import {useContext, useEffect, useState} from "react";
import useAuthHeader from "../hooks/useAuthHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faPercent} from "@fortawesome/free-solid-svg-icons";
import Search from "../components/Search/Search";
import FormDrawer from "../components/FormDrawer/FormDrawer";
import createPartner from "../api/partner/createPartner";
import LoadingContext from "../contexts/LoadingContext";
import {EditOutlined, SecurityScanOutlined} from "@ant-design/icons";
import getFeesChildPartner from "../api/child-partner/getFeesChildPartner";
import EditTableCell from "../components/Table/EditTableCell/EditTableCell";
import getChildPartner from "../api/partner/getChildPartner";
import createChildPartner from "../api/partner/createChildPartner";
import updateChildPartner from "../api/partner/updateChildPartner";
import changePasswordChildPartner from "../api/partner/changePasswordChildPartner";
import updateFeeChildPartner from "../api/child-partner/updateFeeChildPartner";

function ChildPartner() {
    const [data,setData] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const accessToken = useAuthHeader();
    const [form] = Form.useForm();
    const [formAdd] = Form.useForm();
    const [formFee] = Form.useForm();
    const [formIpAddress] = Form.useForm();
    const [open,setOpen] = useState(false);
    const [openFormPassword,setOpenFormPassword] = useState(false);
    const [openModelIpAddress, setOpenIpAddress] = useState(false);
    const [tableLoadingIpAddress,setTableLoadingIpAddress] = useState(false);
    const [record,setRecord] = useState({});
    const [loadingBtnIpAddress,setLoadingBtnIpAddress] = useState(false);
    const [openModalFee,setOpenModalFee] = useState(false);
    const [tableLoadingFee,setTableLoadingFee] = useState(false);
    const [dataSourceFee,setDataSourceFee] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const {loading,setLoading} = useContext(LoadingContext);
    const [editingKey, setEditingKey] = useState('');
    const [editingPartner, setEditingPartner] = useState('');
    const [formPartner] = Form.useForm();
    const [formBalance] = Form.useForm();
    const [formTelegram] = Form.useForm();
    const [openModalTelegram, setOpenModalTelegram] = useState(false);
    const [formPassword] = Form.useForm();
    const [summaryData, setSummaryData] = useState({
        totalBalance: 0
    });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [balance, setBalance] = useState(0);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const permissionOptions = [
        { value: 'view_pay_in', label: 'Xem IN' },
        { value: 'view_pay_out', label: 'Xem OUT' },
        { value: 'view_transactions', label: 'Xem giao dịch' },
        { value: 'view_hooks', label: 'Xem hook' },
        { value: 'view_withdrawals', label: 'Xem rút tiền' },
        { value: 'view_statistics', label: 'Xem thống kê' },
        { value: 'view_deposits', label: 'Xem nạp tiền' },
        { value: 'view_balance', label: 'Xem số dư' },
    ];

    const isEditing = (_record) => _record.userFeeId === editingKey;
    const isEditingPartner = (_record) => _record.userId === editingPartner;

    const cancel = () => {
        setEditingKey('');
    };

    const cancelPartner = () => {
        setEditingPartner('');
    }

    const items = [
        {
            name: 'name',
            placeholder: 'Tên tài khoản con',
            type: 'text'
        },
        {
            name: 'username',
            placeholder: 'Tên đăng nhập',
            type: 'text'
        }
    ]

    const itemAdds = [
        {
            name: 'name',
            placeholder: 'Nhập tên',
            type: 'text',
            label: 'Tên',
            required: true
        },
        {
            name: 'username',
            placeholder: 'Nhập tên tài khoản',
            type: 'text',
            label: 'Tên tài khoản',
            required: true
        },
        {
            name: 'email',
            placeholder: 'Nhập Email',
            type: 'text',
            label: 'Email',
            required: false
        },
        {
            name: 'password',
            placeholder: 'Nhập mật khẩu',
            type: 'password',
            label: 'Mật khẩu',
            required: true
        },
        {
            name: 'rePassword',
            placeholder: 'Nhập lại mật khẩu',
            type: 'password',
            label: 'Xác nhận mật khẩu',
            required: true
        },
        {
            name: 'permissions',
            placeholder: 'Chọn quyền',
            type: 'checkbox-group',
            label: 'Quyền hạn',
            required: true,
            options: permissionOptions
        },
    ]

    const columns = [
        {
            title: 'ID',
            dataIndex: 'userId',
            sorter: true,
            align: 'center'
        },
        {
            title: 'Tên',
            dataIndex: 'name',
            align: 'center',
            editable: true,
            inputType: 'text',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'username',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            align: 'center',
            editable: true,
            inputType: 'text',
            render: (value) => {
                return (value) ? <Tag>{value}</Tag> : <Tag>Trống</Tag>
            }
        },
        {
            title: 'Quyền truy cập',
            dataIndex: 'permissions',
            align: 'center',
            editable: true,
            inputType: 'checkbox-group',
            options: permissionOptions,
            render: (permissions) => {
                return (
                    <Space size={[0, 8]} wrap>
                        {permissions?.map((permission) => (
                            <Tag color="blue" key={permission}>
                                {permissionOptions.find(opt => opt.value === permission)?.label || permission}
                            </Tag>
                        ))}
                    </Space>
                )
            }
        },
        {
            title: 'Xác thực 2 lớp',
            dataIndex: 'is2faEnabled',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Thao tác',
            dataIndex: 'operation',
            align: 'center',
            width: '150px',
            render: (_, record) => {
                const editable = isEditingPartner(record);
                return editable ? (
                    <Space>
                        <Button
                            type={'primary'}
                            onClick={() => savePartner(record.userId)}
                            ghost={true}
                        >Lưu</Button>
                        <Button
                            type={'dashed'}
                            onClick={cancelPartner}
                            danger={true}
                        >Hủy</Button>
                    </Space>
                ) : (
                    <>
                        <Button
                            type="link"
                            disabled={editingPartner !== ''}
                            onClick={() => editPartner(record)}
                        >
                            <EditOutlined/>
                        </Button>
                        <Button
                            type="link"
                            onClick={() => handleOpenChangePassword(record)}
                        >
                            <SecurityScanOutlined/>
                        </Button>
                        <Button
                            type="link"
                            onClick={() => handleFee(record)}
                        >
                            <FontAwesomeIcon icon={faPercent}/>
                        </Button>
                    </>
                );
            }
        }
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditingPartner(record),
                options: col.options
            }),
        };
    });

    const handleOpenChangePassword = async (_record) => {
        setRecord(_record);
        setOpenFormPassword(true);
    };

    const handleChangePassword = async () => {
        try {
            const values = await formPassword.validateFields();
            setLoading(true);
            const response = await changePasswordChildPartner(accessToken, {
                userId: record.userId,
                ...values
            });
            if (response.success) {
                messageApi.success('Đổi mật khẩu thành công');
                setOpenFormPassword(false);
                formPassword.resetFields();
            } else {
                messageApi.error(response.message || 'Đổi mật khẩu thất bại');
            }
        } catch (e) {
            console.log(e);
            messageApi.error('Có lỗi xảy ra khi đổi mật khẩu');
        } finally {
            setLoading(false);
        }
    };

    const fetchDataPartners = async () => {
        try {
            setTableLoading(true);
            const response = await getChildPartner(accessToken, tableParams);
            if (response.success) {
                setData(response.data.data);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: response.data.total
                    }
                });
            } else {
                messageApi.error(response.message || 'Không thể tải danh sách tài khoản con');
            }
        } catch (e) {
            console.log(e);
            messageApi.error('Có lỗi xảy ra khi tải danh sách tài khoản con');
        } finally {
            setTableLoading(false);
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const handleSearch = () => {
        const values = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            ...values
        });
    };

    const handleSubmitAdd = (values) => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await createChildPartner(accessToken, values);
                if (response.success) {
                    messageApi.success('Thêm tài khoản con thành công');
                    setOpen(false);
                    formAdd.resetFields();
                    await fetchDataPartners();
                } else {
                    messageApi.error(response.message || 'Thêm tài khoản con thất bại');
                }
            } catch (e) {
                console.log(e);
                messageApi.error('Có lỗi xảy ra khi thêm tài khoản con');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    };

    const editPartner = (_record) => {
        formPartner.setFieldsValue({
            name: _record.name,
            email: _record.email,
            is2faEnabled: _record.is2faEnabled,
            permissions: _record.permissions || []
        });
        setEditingPartner(_record.userId);
    };

    const savePartner = async (userId) => {
        try {
            const row = await formPartner.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => userId === item.userId);
            if (index > -1) {
                const item = newData[index];
                const response = await updateChildPartner(accessToken, {
                    userId: userId,
                    ...row
                });
                if (response.success) {
                    messageApi.success('Cập nhật thông tin thành công');
                    newData.splice(index, 1, {
                        ...item,
                        ...row,
                    });
                    setData(newData);
                    setEditingPartner('');
                } else {
                    messageApi.error(response.message || 'Cập nhật thông tin thất bại');
                }
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
            messageApi.error('Có lỗi xảy ra khi cập nhật thông tin');
        }
    };

    const columnFees = [
        {
            title: 'ID',
            dataIndex: 'userFeeId',
            align: 'center',
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Giảm IN (%)',
            dataIndex: 'payInFee',
            align: 'center',
            editable: true,
        },
        {
            title: 'Giảm OUT (%)',
            dataIndex: 'payOutFee',
            align: 'center',
            editable: true,
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,_record) => {
                const editable = isEditing(_record);
                return editable ? (
                    <Space>
                        <Button
                            type={'primary'}
                            onClick={() => save(_record.userFeeId)}
                            ghost={true}
                        >Lưu</Button>
                        <Button
                            type={'dashed'}
                            onClick={cancel}
                            danger={true}
                        >Hủy</Button>
                    </Space>
                ) : (
                    <Button icon={<EditOutlined/>} disabled={editingKey !== ''} onClick={() => edit(_record)} type={'primary'}>Chỉnh sửa</Button>
                );
            }
        }
    ];

    const mergedColumnFees = columnFees.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (_record) => ({
                _record,
                inputType: 'number',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(_record),
            }),
        };
    });

    const handleFee = async (_record) => {
        setOpenModalFee(true);
        await fetchFees(_record.userId);
        setRecord(_record);
    };

    const fetchFees = async (userId) => {
        try {
            setTableLoadingFee(true);
            const response = await getFeesChildPartner(accessToken, userId);
            if (response.success) {
                setDataSourceFee(response.data);
            } else {
                messageApi.error(response.message || 'Không thể tải thông tin chiết khấu');
            }
        } catch (e) {
            console.log(e);
            messageApi.error('Có lỗi xảy ra khi tải thông tin chiết khấu');
        } finally {
            setTableLoadingFee(false);
        }
    };

    const edit = (_record) => {
        formFee.setFieldsValue({
            payInFee: 0,
            payOutFee: 0,
            ..._record,
        });
        setEditingKey(_record.userFeeId);
    };

    const save = async (userFeeId) => {
        try {
            setTableLoadingFee(true);
            const row = await formFee.validateFields();
            const params = {
                userFeeId,
                ...row
            };
            const response = await updateFeeChildPartner(accessToken, params);
            if (response.success) {
                const newData = [...dataSourceFee];
                const index = newData.findIndex((item) => userFeeId === item.userFeeId);
                if (index > -1) {
                    const item = newData[index];
                    newData.splice(index, 1, {
                        ...item,
                        ...row,
                    });
                    setDataSourceFee(newData);
                    setEditingKey('');
                    messageApi.success('Cập nhật chiết khấu thành công');
                }
            } else {
                messageApi.error(response.message || 'Cập nhật chiết khấu thất bại');
            }
        } catch (e) {
            console.log('Validate Failed:', e);
            messageApi.error('Có lỗi xảy ra khi cập nhật chiết khấu');
        } finally {
            setTableLoadingFee(false);
        }
    };

    useEffect(() => {
        fetchDataPartners();
    }, [JSON.stringify(tableParams)]);

    return (
        <Container>
            {contextHolder}
            <div className="mb-4">
                <Search items={items} form={form} handleSearch={handleSearch}/>
            </div>
            <div className="mb-4" style={{
                marginBottom: '20px'
            }}>
                <Button
                    type="primary"
                    icon={<FontAwesomeIcon icon={faAdd} />}
                    onClick={() => setOpen(true)}
                >
                    Thêm tài khoản con
                </Button>
            </div>
            <Form
                form={formAdd}
                onFinish={handleSubmitAdd}
            >
                <FormDrawer
                    title="Thêm tài khoản con"
                    width={500}
                    open={open}
                    onClose={() => setOpen(false)}
                    items={itemAdds}
                    onSubmit={formAdd.submit}
                />
            </Form>
            <Modal
                title="Đổi mật khẩu"
                open={openFormPassword}
                onOk={handleChangePassword}
                onCancel={() => {
                    setOpenFormPassword(false);
                    formPassword.resetFields();
                }}
                okText="Xác nhận"
                cancelText="Hủy"
            >
                <Form
                    form={formPassword}
                    layout="vertical"
                    name="form_in_modal"
                >
                    <Form.Item
                        name="password"
                        label="Mật khẩu"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập mật khẩu!',
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        name="rePassword"
                        label="Xác nhận mật khẩu"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập lại mật khẩu!',
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                </Form>
            </Modal>
            <Form form={formPartner} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditTableCell,
                        },
                    }}
                    bordered
                    size="small"
                    columns={mergedColumns}
                    rowKey={'userId'}
                    dataSource={data}
                    pagination={tableParams.pagination}
                    loading={tableLoading}
                    onChange={handleTableChange}
                    scroll={{
                        x: 1500
                    }}
                />
            </Form>
            <Modal
                title="Danh sách thông tin chiết khấu"
                open={openModalFee}
                onCancel={() => {
                    setOpenModalFee(false);
                    setEditingKey('');
                }}
                width={1000}
                footer={null}
            >
                <Form form={formFee} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditTableCell,
                            },
                        }}
                        bordered
                        size="small"
                        columns={mergedColumnFees}
                        rowKey={'userFeeId'}
                        dataSource={dataSourceFee}
                        loading={tableLoadingFee}
                        scroll={{
                            x: 800
                        }}
                    />
                </Form>
            </Modal>
        </Container>
    );
}

export default ChildPartner; 
